import React, { useState, useEffect } from 'react';
import PDFViewer from './PDFViewer';

// 🚀 PDF Origin Mismatch 해결을 위한 래퍼 컴포넌트
// 백엔드 URL을 바로 iframe에 전달하면 Origin Mismatch 오류 발생
// -> fetch로 Blob을 받아와서 로컬 Blob URL로 변환하여 전달
export default function TemplateSampleViewer({ url, templateName }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;
        const loadPdf = async () => {
            if (!url) {
                setBlobUrl(null);
                return;
            }

            try {
                setLoading(true);
                setError(null);
                console.log(`📥 템플릿 샘플 로드 시작: ${url}`);

                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`파일을 불러오는데 실패했습니다 (${response.status})`);
                }

                const blob = await response.blob();
                if (active) {
                    const objectUrl = URL.createObjectURL(blob);
                    console.log('✅ Blob URL 생성 완료:', objectUrl);
                    setBlobUrl(objectUrl);
                }
            } catch (err) {
                console.error('❌ 템플릿 샘플 로드 오류:', err);
                if (active) {
                    setError(err.message);
                }
            } finally {
                if (active) {
                    setLoading(false);
                }
            }
        };

        loadPdf();

        return () => {
            active = false;
            // Cleanup blob URL to prevent memory leaks
            if (blobUrl) {
                URL.revokeObjectURL(blobUrl);
            }
        };
    }, [url]);

    if (error) {
        return (
            <div className="flex items-center justify-center h-full text-red-500 flex-col gap-2 p-4 text-center">
                <p>⚠️ 샘플 파일을 불러올 수 없습니다.</p>
                <p className="text-xs text-gray-500">{error}</p>
            </div>
        );
    }

    if (loading) {
        return (
            <div className="flex items-center justify-center h-full text-gray-500">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-2"></div>
                <p>로딩 중...</p>
            </div>
        );
    }

    if (!blobUrl) {
        return (
            <div className="flex items-center justify-center h-full text-gray-400">
                <p>표시할 샘플 이미지가 없습니다.</p>
            </div>
        );
    }

    // PDFViewer에 Blob URL 전달
    // Blob URL은 Same-Origin으로 취급되어 오류 해결
    const isPdf = url.toLowerCase().endsWith('.pdf');

    if (isPdf) {
        return (
            <div className="relative w-full h-full flex-1" style={{ minHeight: 0 }}>
                <PDFViewer
                    file={blobUrl}
                    pageNumber={1}
                    onLoadSuccess={() => console.log(`📋 템플릿(${templateName}) PDF 준비 완료`)}
                />
            </div>
        );
    } else {
        return (
            <div className="relative w-full h-full flex-1 overflow-auto flex items-center justify-center p-4" style={{ minHeight: 0 }}>
                <img
                    src={blobUrl} // Blob URL 사용
                    alt={`${templateName} 샘플`}
                    className="max-w-full max-h-full object-contain"
                />
            </div>
        );
    }
}
